




























































import AbpBase from '../../../lib/abpbase'
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import {
    EditDrugStorageStockRedDashed,
    QueryPharmacyReceiptStockIn,
    QueryPharmacyReceiptStockOut,
    QueryPharmacyReceiptStockBreakage,
    QueryPharmacyReceiptStockCheck,
    QueryPharmacyReceiptRefund,
    QueryPharmacyReceiptDiscount,
    QueryPharmacyStockInDetailById,
    QueryPharmacyStockOutDetailById,
    QueryPharmacyStockBreakageDetailById,
    QueryPharmacyStockCheckDetailById,
    QueryPharmacyStockRefundDetailById,
    QueryPharmacyStockDiscountDetailById,
} from '../../../api/pharmacy'

import {GetMeteringList} from '../../../api/basicDictionary'
import Util from '../../../lib/util'
import u from 'underscore'

//单据打印组件
import print from '../../../components/print/stockBills.vue'

@Component({
    components:{print}
})
export default class Bills extends AbpBase {
	@Watch('type')
    Watchtype(val: any, oldVal: any) { 
        this.date = []
        this.receiptNo = ''
        this.input.receiptNo = ''
        this.input.stockDateStart = ''
        this.input.stockDateEnd = ''
    }
    @Watch('receiptNo')
    WatchreceiptNo(val: any, oldVal: any) { 
        this.input.receiptNo = this.receiptNo
        this.fillBillsData()
    }
    @Watch('date')
    Watchdate(val: any, oldVal: any) { 
        // this.input.receiptNo = this.receiptNo
        this.input.stockDateStart = this.date[0]
        this.input.stockDateEnd = this.date[1]
        this.fillBillsData()
    }
    printTitle = ''
    printShow:Boolean = false;
    printData = {
        list:[],
        title:[
            '单据编码',
            '药品名称',
            '生产厂家',
            '数量',
            '单位',
            '进价',
            '进价总额',
            '零价',
            '零价总额',
            '批号',
            '有效日期',
            '入库人',
            '入库日期',
        ]
    }


    list = []//table数据源
    detailList = []//table数据源
	
	table = {
        loading:false,
        detailLoading:false,
    }
    
    //保存打印loding
    saveLoding:Boolean = false;

    receiptNo="";
    type=1
    typeName="入库"
    typeOptions=[
        {value:1,text:'入库'},
        {value:2,text:'出库'},
        // {value:3,text:'报损'},
        // {value:4,text:'调价'},
        {value:5,text:'盘点'},
        // {value:6,text:'退货'},
    ]
    input:any = {
        receiptNo:this.receiptNo,
        stockDateStart:'',
        stockDateEnd:'',
        pageSize: 1000,
        page: 1
    }
    detailInput:any = {
        stockInId:null,
        stockOutId:null,
        stockCheckId:null,
        stockStoreageId:null,
        stockRefundId:null,
        stockDiscountId:null,
        pageSize:1000,
        page:1
    }
    date = [];

    created() {
        this.queryReceiptDrugStorageStockIn()
    }
    //搜索
    search(){
        this.input.receiptNo = this.receiptNo
        this.input.stockDateStart = this.date[0]
        this.input.stockDateEnd = this.date[1]
        this.fillBillsData()
    }
    //类型选择
    typeChange(){
       this.renderColumns()
       this.fillBillsData()
    }
    //调用单据数据
    fillBillsData(){
        this.detailList = []
        switch(this.type){
           case 1:
           this.typeName="入库"
           this.queryReceiptDrugStorageStockIn()
           break;
           case 2:
           this.typeName="出库"
           this.queryReceiptDrugStorageStockOut()
           break;
           case 3:
           this.typeName="报损"
           this.queryReceiptDrugStorageStockBreakage()
           break;
           case 4:
           this.typeName="调价"
           this.queryReceiptDrugStorageStockDiscount()
           break;
           case 5:
           this.typeName="盘点"
           this.queryReceiptDrugStorageStockCheck()
           break;
           case 6:
           this.typeName="退货"
           this.queryReceiptDrugStorageStockRefund()
           break;
       }
    }
    //明细选择
    tabChange(currentRow:any,oldCurrentRow:any){
        if(currentRow){
           console.log(currentRow)
           this.getTalDetail(currentRow.id,this.type)
        }
    }
    redDashed(c:any){
        this.editDrugStorageStockRedDashed(c.id,c.deptId)
    }
    //红冲
    async editDrugStorageStockRedDashed(id,deptId){
        let data = {
            actionType:this.type,
            stockId:id,
            departId:deptId
        }
        let res = await EditDrugStorageStockRedDashed(data)
        if(res.code == 2000){
            // this.$Message.info('操作成功')
            this.fillBillsData()
        }else{
            // this.$Message.error(res.message)
        }
    }
    //入库单
    async queryReceiptDrugStorageStockIn(){
        this.table.loading = true;
        let res = await QueryPharmacyReceiptStockIn(this.input)
        this.list = res.data.items
        this.table.loading = false;
        if(this.list.length>0){
            this.list[0]._highlight = true;
            this.getTalDetail(this.list[0].id,1)
        }
    }
    //出库单
    async queryReceiptDrugStorageStockOut(){
        this.table.loading = true;
        let res = await QueryPharmacyReceiptStockOut(this.input)
        this.list = res.data.items
        this.table.loading = false;
        if(this.list.length>0){
            this.list[0]._highlight = true;
            this.getTalDetail(this.list[0].id,2)
        }
    }
    //报损单
    async queryReceiptDrugStorageStockBreakage(){
        this.table.loading = true;
        let res = await QueryPharmacyReceiptStockBreakage(this.input)
        this.list = res.data.items
        this.table.loading = false;
        if(this.list.length>0){
            this.list[0]._highlight = true;
            this.getTalDetail(this.list[0].id,3)
        }
    }
    //调价单
    async queryReceiptDrugStorageStockDiscount(){
        this.table.loading = true;
        let res = await QueryPharmacyReceiptDiscount(this.input)
        this.list = res.data.items
        this.table.loading = false;
        if(this.list.length>0){
            this.list[0]._highlight = true;
            this.getTalDetail(this.list[0].id,4)
        }
    }
    //盘点单
    async queryReceiptDrugStorageStockCheck(){
        this.table.loading = true;
        let res = await QueryPharmacyReceiptStockCheck(this.input)
        this.list = res.data.items
        this.table.loading = false;
        if(this.list.length>0){
            this.list[0]._highlight = true;
            this.getTalDetail(this.list[0].id,5)
        }
    }
    //退货单
    async queryReceiptDrugStorageStockRefund(){
        this.table.loading = true;
        let res = await QueryPharmacyReceiptRefund(this.input)
        this.list = res.data.items
        this.table.loading = false;
        if(this.list.length>0){
            this.list[0]._highlight = true;
            this.getTalDetail(this.list[0].id,6)
        }
    }
    
    //获取详情数据
    async getTalDetail(id,type){
        let res;
        this.table.detailLoading = true;
        switch(type){
            case 1: 
            this.detailInput.stockInId = id
            res  = await QueryPharmacyStockInDetailById(this.detailInput)
            this.detailList = res.data.pharmacyStockInDetailResult.items   
            if(this.detailList.length>0){
                this.detailList.push({
                    drugName:'合计',
                    batchPurchasePrice:res.data.sumPurchasePrice,
                    batchZeroPrice:res.data.sumZeroPrice,
                })
            }
            break;
            case 2: 
            this.detailInput.stockOutId = id
            res  = await QueryPharmacyStockOutDetailById(this.detailInput)
            this.detailList = res.data.pharmacyStockOutDetailResult.items
            if(this.detailList.length>0){
                this.detailList.push({
                    drugName:'合计',
                    batchPurchasePrice:res.data.sumPurchasePrice,
                    batchZeroPrice:res.data.sumZeroPrice,
                })
            }
            break;
            case 3: 
            this.detailInput.stockBreakageId = id
            res  = await QueryPharmacyStockBreakageDetailById(this.detailInput)
            this.detailList = res.data.pharmacyStockBreakageDetailResult.items
            if(this.detailList.length>0){
                this.detailList.push({
                    drugName:'合计',
                    batchPurchasePrice:res.data.sumPurchasePrice,
                    batchZeroPrice:res.data.sumZeroPrice,
                })
            }
            break;
            case 4: 
            this.detailInput.stockDiscountId = id
            res  = await QueryPharmacyStockDiscountDetailById(this.detailInput)
            this.detailList = res.data.pharmacyStockDiscountDetailResult.items
            if(this.detailList.length>0){
                this.detailList.push({
                    drugName:'合计',
                    zeroPriceDiscount:res.data.sumDiscountZeroPrice,
                })
            }
            
            break;
            case 5: 
            this.detailInput.stockCheckId = id
            res  = await QueryPharmacyStockCheckDetailById(this.detailInput)
            this.detailList = res.data.pharmacyStockCheckDetailResult.items
            if(this.detailList.length>0){
                this.detailList.push({
                    drugName:'合计',
                    batchCkPurchasePrice:res.data.sumCkPurchasePrice,
                    zeroCkPrice:res.data.sumCkZeroPrice,
                })
                
            }
            break;
            case 6: 
            this.detailInput.stockRefundId = id
            res  = await QueryPharmacyStockRefundDetailById(this.detailInput)
            this.detailList = res.data.pharmacyStockRefundDetailResult.items
            if(this.detailList.length>0){
                this.detailList.push({
                    drugName:'合计',
                    batchPurchasePrice:res.data.sumPurchasePrice,
                    batchZeroPrice:res.data.sumZeroPrice,
                })
            }
            break;
        }
        this.table.detailLoading = false;
    }
    //不同类型单据columns重新渲染
    renderColumns(){
        switch(this.type){
            case 1:
            this.detailColumns = [{
                title: "药品名称",
                key: 'drugName'
            },{
                title: "生产厂家",
                key: 'manufacturer'
            },{
                title: "规格",
                key: 'medicineModel'
            },{
                title: "数量",
                key: 'quantity'
            },{
                title: "单位",
                key: 'unitName'
            },{
                title: "进价",
                key: 'purchasePrice'
            },{
                title: "进价金额",
                key: 'batchPurchasePrice'
            },{
                title: "零价",
                key: 'zeroPrice'
            },{
                title: "零价金额",
                key: 'batchZeroPrice'
            },{
                title: "批号",
                key: 'batchNo'
            },{
                title: "有效日期",
                key: 'validityPeriod',
                render: (h: any, params: any) => {
                     return h('span',Util.formatTime(params.row.validityPeriod))
                }
            }]
            break;
            case 2:
            this.detailColumns = [{
                title: "药品名称",
                key: 'drugName'
            },{
                title: "生产厂家",
                key: 'manufacturer'
            },{
                title: "规格",
                key: 'medicineModel'
            },{
                title: "数量",
                key: 'quantity'
            },{
                title: "单位",
                key: 'unitName'
            },{
                title: "进价",
                key: 'purchasePrice'
            },{
                title: "进价金额",
                key: 'batchPurchasePrice'
            },{
                title: "零价",
                key: 'zeroPrice'
            },{
                title: "零价金额",
                key: 'batchZeroPrice'
            },{
                title: "批号",
                key: 'batchNo'
            },{
                title: "科室",
                key: 'deptName'
            }]
            break;
            case 3:
            this.detailColumns = [{
                title: "药品名称",
                key: 'drugName'
            },{
                title: "生产厂家",
                key: 'manufacturer'
            },{
                title: "规格",
                key: 'medicineModel'
            },{
                title: "数量",
                key: 'quantity'
            },{
                title: "单位",
                key: 'unitName'
            },{
                title: "进价",
                key: 'purchasePrice'
            },{
                title: "进价金额",
                key: 'batchPurchasePrice'
            },{
                title: "零价",
                key: 'zeroPrice'
            },{
                title: "零价金额",
                key: 'batchZeroPrice'
            },{
                title: "批号",
                key: 'batchNo'
            }]
            break;
            case 4:
            this.detailColumns = [{
                title: "药品名称",
                key: 'drugName'
            },{
                title: "生产厂家",
                key: 'manufacturer'
            },{
                title: "规格",
                key: 'medicineModel'
            },{
                title: "数量/单位",
                key: 'transQuantity'
            },{
                title: "零价",
                key: 'zeroPrice'
            },{
                title: "现零价",
                key: 'nowZeroPrice'
            },{
                title: "零价调价",
                key: 'zeroPriceDiscount'
            },{
                title: "批号",
                key: 'batchNo'
            }]
            break;
             case 5:
            this.detailColumns = [{
                title: "药品名称",
                key: 'drugName'
            },{
                title: "生产厂家",
                key: 'manufacturer'
            },{
                title: "规格",
                key: 'medicineModel'
            },{
                title: "原数量",
                key: 'quantity'
            },{
                title: "现数量",
                key: 'nowQuantity'
            },{
                title: "盘亏/盘盈数量",
                key: 'checkQuantity'
            },{
                title: "单位",
                key: 'unitName'
            },{
                title: "进价",
                key: 'purchasePrice'
            },{
                title: "进价盘点金额",
                key: 'batchCkPurchasePrice'
            },{
                title: "零价",
                key: 'zeroPrice'
            },{
                title: "零价盘点金额",
                key: 'zeroCkPrice'
            },{
                title: "批号",
                key: 'batchNo'
            }]
            break;
            case 6:
            this.detailColumns = [{
                title: "药品名称",
                key: 'drugName'
            },{
                title: "生产厂家",
                key: 'manufacturer'
            },{
                title: "规格",
                key: 'medicineModel'
            },{
                title: "数量",
                key: 'quantity'
            },{
                title: "单位",
                key: 'unitName'
            },{
                title: "进价",
                key: 'purchasePrice'
            },{
                title: "进价金额",
                key: 'batchPurchasePrice'
            },{
                title: "零价",
                key: 'zeroPrice'
            },{
                title: "零价金额",
                key: 'batchZeroPrice'
            },{
                title: "批号",
                key: 'batchNo'
            }]
            break;

        }
    }
    //表格高度
    get tableHeight(){
        return (window.innerHeight-450)/2
    }
    //登陆人
    get staffName(){
        return this.$store.state.session.user?this.$store.state.session.user.name:''
    }
    //数据导出
    exportData(){
        (this.$refs.table as any).exportCsv({
            filename:`药房${this.typeName}单`,
            original:false
        })
    }
     //数据导出
    exportDetailData(){
        (this.$refs.detailTable as any).exportCsv({
            filename:`药房${this.typeName}明细单`,
            original:false
        })
    }
    //单据打印
    billsPrint(){
        if(this.list.length<1){
            this.$Message.info('请选择单据')
            return false;
        }
        switch(this.type){
            case 1:
            this.printTitle = '药房入库单'
            this.printData.title = [
            '单据编码',
            '药品名称',
            '生产厂家',
            '数量',
            '单位',
            '进价',
            '进价总额',
            '零价',
            '零价总额',
            '批号',
            '有效日期',
            '入库人',
            '入库日期',
            ]
            this.printData.list = []
            this.detailList.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.drugName,
                    item.manufacturer,
                    item.quantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchPurchasePrice,
                    item.zeroPrice,
                    item.batchZeroPrice,
                    item.batchNo,
                    Util.formatTime(item.validityPeriod),
                    item.staffName,
                    index == this.detailList.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true
            break;
            case 2:
            this.printTitle = '药房出库单'
            this.printData.title = [
            '单据编码',
            '药品名称',
            '生产厂家',
            '数量',
            '单位',
            '进价',
            '进价总额',
            '零价',
            '零价总额',
            '批号',
            '科室',
            '出库人',
            '出库日期',
            ]
            this.printData.list = []
            this.detailList.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.drugName,
                    item.manufacturer,
                    item.quantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchPurchasePrice,
                    item.zeroPrice,
                    item.batchZeroPrice,
                    item.batchNo,
                    item.deptName,
                    item.staffName,
                    index == this.detailList.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true
            break;
            case 3:
            this.printTitle = '药房报损单'
            this.printData.title = [
            '单据编码',
            '药品名称',
            '生产厂家',
            '数量',
            '单位',
            '进价',
            '进价总额',
            '零价',
            '零价总额',
            '批号',
            '报损人',
            '报损日期',
            ]
            this.printData.list = []
            this.detailList.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.drugName,
                    item.manufacturer,
                    item.quantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchPurchasePrice,
                    item.zeroPrice,
                    item.batchZeroPrice,
                    item.batchNo,
                    item.staffName,
                    index == this.detailList.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true
            break;
            case 4:
            this.printTitle = '药房调价单'
            this.printData.title = [
            '单据编码',
            '药品名称',
            '生产厂家',
            '数量',
            '单位',
            '原零价',
            '现零价',
            '零价调价',
            '批号',
            '调价人',
            '调价日期',
            ]
            this.printData.list = []
            this.detailList.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.drugName,
                    item.manufacturer,
                    item.quantity,
                    item.unitName,
                    item.zeroPrice,
                    item.nowZeroPrice,
                    item.zeroPriceDiscount,
                    item.batchNo,
                    item.staffName,
                    index == this.detailList.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true
            break;
            case 5:
            this.printTitle = '药房盘点单'
            this.printData.title = [
            '单据编码',
            '药品名称',
            '生产厂家',
            '原数量',
            '现数量',
            '盘亏/盘盈数量',
            '单位',
            '进价',
            '进价盘点',
            '零价',
            '零价盘点',
            '批号',
            '盘点人',
            '盘点日期',
            ]
            this.printData.list = []
            this.detailList.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.drugName,
                    item.manufacturer,
                    item.quantity,
                    item.nowQuantity,
                    item.checkQuantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchCkPurchasePrice,
                    item.zeroPrice,
                    item.zeroCkPrice,
                    item.batchNo,
                    item.staffName,
                    index == this.detailList.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true
            break;
            case 6:
            this.printTitle = '药房退货单'
            this.printData.title = [
            '单据编码',
            '药品名称',
            '生产厂家',
            '数量',
            '单位',
            '进价',
            '进价总额',
            '零价',
            '零价总额',
            '批号',
            '退货人',
            '退货日期',
            ]
            this.printData.list = []
            this.detailList.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.drugName,
                    item.manufacturer,
                    item.quantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchPurchasePrice,
                    item.zeroPrice,
                    item.batchZeroPrice,
                    item.batchNo,
                    item.staffName,
                    index == this.detailList.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true
            break;
        }
    }
    //打印完成回调
    printBack(){
        this.printShow = false;
    }
	columns = [{
		title: '单据号',
        key: 'receiptNo',
        width:140
	},{
		title: "单据类型",
		key: 'receiptType'
	},{
		title: "科室",
		key: 'deptName'
	},{
		title: "进价金额",
		key: 'sumPurchasePrice'
	},{
		title: "零价金额",
		key: 'sumZeroPrice'
	},{
		title: "日期",
        key: 'stockInDate',
        render: (h:any,params: any) =>{
            return h('span',
                params.row.stockInDate?params.row.stockInDate:
                params.row.stockOutDate?params.row.stockOutDate:
                params.row.stockRefundDate?params.row.stockRefundDate:
                params.row.stockBreakageDate?params.row.stockBreakageDate:
                params.row.stockDiscountDate?params.row.stockDiscountDate:params.row.stockCheckDate
            )
        }
    },{
		title: "操作员",
		key: 'staffName'
	},{title: this.L('Actions'),
        key: 'Actions',
        width:90,
		render: (h: any, params: any) => {
            if(params.row.receiptType!='调价')
			if(!params.row.isRedDashed){
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small',
                        },
                        style: {
                            letterSpacing: '10px',
                            width:'51px',
                            overflow:'hidden'
                        },
                        on: {
                            click: () => {
                                this.redDashed(params.row)
                            }
                        }
                    },"红冲")
                ])
            }else{
                 return h('div', [
                    h('Button', {
                        props: {
                            type: 'success',
                            size: 'small'
                        },
                        style: {
                            width:'51px',
                            overflow:'hidden'
                        },
                    },'已红冲')
                ])
            }
		}
   
    }]
    // 明细
    detailColumns:any = [{
        title: "药品名称",
        key: 'drugName'
    },{
        title: "生产厂家",
        key: 'manufacturer'
    },{
        title: "规格",
        key: 'medicineModel'
    },{
        title: "数量",
        key: 'quantity'
    },{
        title: "单位",
        key: 'unitName'
    },{
        title: "进价",
        key: 'purchasePrice'
    },{
        title: "进价金额",
        key: 'batchPurchasePrice'
    },{
        title: "零价",
        key: 'zeroPrice'
    },{
        title: "零价金额",
        key: 'batchZeroPrice'
    },{
        title: "批号",
        key: 'batchNo'
    },{
        title: "有效日期",
        key: 'validityPeriod',
        render: (h: any, params: any) => {
            return h('span',Util.formatTime(params.row.validityPeriod))
        }
    }]
    
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pharmacy/bills/index.vue